import { createBackofficeServerClient } from '@packages/gql/src/createServerClient';
import { cached } from '@packages/shared/src/utils/cached/cached';
import { CONTENT_CACHE_TTL_SECONDS } from '@packages/shared/src/utils/contentCacheTtl/contentCacheTtl';
import {
  type AppConfigData,
  fetchAppConfig,
  isCcConsumerShopConfigEnabled,
} from './fetchAppConfig';

/**
 * Pages router counterpart of `getAppConfigData`: plain server client behind the
 * process-wide memory cache. Same TTL, no tag-based revalidation.
 */
export const getPagesRouterAppConfigData = (
  locale: string,
  cookieValue: string | undefined,
): Promise<AppConfigData | null> =>
  isCcConsumerShopConfigEnabled(cookieValue)
    ? cached(
        `app-config-${locale}`,
        () => fetchAppConfig(createBackofficeServerClient(), locale),
        CONTENT_CACHE_TTL_SECONDS.config * 1000,
      )()
    : Promise.resolve(null);
